export enum Language {
    spanish = 'es',
    english = 'en'
}